import React, { Component } from "react";

export default class CameraFeed extends Component {
  /**
   * Processes available devices and identifies one by the label
   * @memberof CameraFeed
   * @instance
   */
  processDevices(devices) {
    devices.forEach((device) => {
      console.log(device.label);
      this.setDevice(device);
    });
  }

  /**
   * Sets the active device and starts playing the feed
   * @memberof CameraFeed
   * @instance
   */
  async setDevice(device) {
    const { deviceId } = device;
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { deviceId },
    });
    this.videoPlayer.srcObject = stream;
    this.videoPlayer.play();
  }

  /**
   * On mount, grab the users connected devices and process them
   * @memberof CameraFeed
   * @instance
   * @override
   */
  async componentDidMount() {
    const cameras = await navigator.mediaDevices.enumerateDevices();
    this.processDevices(cameras);
  }

  /**
   * Handles taking a still image from the video feed on the camera
   * @memberof CameraFeed
   * @instance
   */
  takePhoto = () => {
    setInterval(() => {
      const context = this.canvas.getContext("2d");
      const img = this.videoPlayer;
      console.log("img123", img);
      context.drawImage(img, 0, 0, 680, 544);
      //this.canvas.toBlob(sendFile);
      var dataURI = this.canvas.toDataURL("image/jpeg");
      this.downloadPhoto(dataURI);
    }, 1000);
  };

  downloadPhoto = (dataURI) => {
    var link = document.createElement("a");
    link.href = dataURI;
    link.download = "Download.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    return (
      <div className="c-camera-feed">
        <div className="c-camera-feed__viewer">
          <video
            ref={(ref) => (this.videoPlayer = ref)}
            width="680"
            heigh="auto"
          />
        </div>
        <button onClick={this.takePhoto}>Take photo!</button>
        <div className="c-camera-feed__stage">
          <canvas width="680" height="544" ref={(ref) => (this.canvas = ref)} />
        </div>
      </div>
    );
  }
}
